module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-4@2x.66fe164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-4@2x.png
// module id = FOl5
// module chunks = 18